import clsx from 'clsx';

import type { ReactNode } from 'react';

import type { StaticImageData } from 'next/image';
import Image from 'next/image';

import { Column, Grid } from '@carbon/react';

import type { Props as ContentDescriptionProps } from '@/components/ContentDescription';
import { ContentDescription } from '@/components/ContentDescription';
import { HorizontalSeparator } from '@/components/HorizontalSeparator';

import styles from './section-header-with-description.module.scss';

export interface Props {
  className?: string;
  title: ReactNode;
  descriptions: ContentDescriptionProps[];
  hasBorderTop?: boolean;
  imageSrc?: StaticImageData;
  imageAlt?: string;
  eyebrow?: string;
  descriptionTitleSize?: 'sm' | 'lg';
  condensed?: boolean;
}

export function SectionHeaderWithDescription({
  className,
  title,
  descriptions,
  hasBorderTop = false,
  imageSrc,
  imageAlt = '',
  eyebrow,
  descriptionTitleSize = 'sm',
  condensed,
}: Props) {
  return (
    <Grid
      className={clsx(styles['section-header-with-description'], className)}
      condensed={condensed}
    >
      {hasBorderTop && (
        <Column sm="100%">
          <HorizontalSeparator className={styles['section-header-with-description__separator']} />
        </Column>
      )}
      {imageSrc && (
        <Column sm="100%">
          <Image
            className={styles['section-header-with-description__img']}
            src={imageSrc}
            alt={imageAlt}
          />
        </Column>
      )}
      {eyebrow && (
        <Column sm="100%" className={styles['section-header-with-description__eyebrow']}>
          <div>{eyebrow}</div>
        </Column>
      )}
      <Column sm={4} md={8} lg={7}>
        <h2 className={styles['section-header-with-description__title']}>{title}</h2>
      </Column>
      <Column sm={0} lg={1}></Column>
      <Column
        sm={4}
        md={8}
        lg={8}
        className={styles['section-header-with-description__descriptions']}
      >
        {descriptions.map((description, index) => (
          <ContentDescription key={index} {...description} titleSize={descriptionTitleSize} />
        ))}
      </Column>
    </Grid>
  );
}
